"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabSolicitudActiva = exports.EstadoPlanificacionConSolicitud = exports.TiposReplanificacion = exports.EstadosParseSolicitudesVacaciones = void 0;
var EstadosParseSolicitudesVacaciones;
(function (EstadosParseSolicitudesVacaciones) {
    EstadosParseSolicitudesVacaciones["ANULADA"] = "Anulada";
    EstadosParseSolicitudesVacaciones["RECHAZADA"] = "Negada";
})(EstadosParseSolicitudesVacaciones = exports.EstadosParseSolicitudesVacaciones || (exports.EstadosParseSolicitudesVacaciones = {}));
var TiposReplanificacion;
(function (TiposReplanificacion) {
    TiposReplanificacion["REPLANIFICACION"] = "RP";
    TiposReplanificacion["REPLANIFICACIONSOLICITADA"] = "RPS";
    TiposReplanificacion["JUSTIFICACION"] = "JF";
})(TiposReplanificacion = exports.TiposReplanificacion || (exports.TiposReplanificacion = {}));
var EstadoPlanificacionConSolicitud;
(function (EstadoPlanificacionConSolicitud) {
    EstadoPlanificacionConSolicitud["EJECUTADO"] = "Ejecutado";
    EstadoPlanificacionConSolicitud["NO_EJECUTADO"] = "No Ejecutado";
    EstadoPlanificacionConSolicitud["PENDIENTE"] = "Pendiente de Ejecutar";
    EstadoPlanificacionConSolicitud["JUSTIFICADA"] = "Justificada";
    // JUSTIFICADA = "Planificada no ejecutada-Justificada",
    EstadoPlanificacionConSolicitud["JUSTIFICACION_INGRESADA"] = "Justificaci\u00F3n Ingresada";
    EstadoPlanificacionConSolicitud["POR_EJECUTAR"] = "Por Ejecutar";
    EstadoPlanificacionConSolicitud["REPLANIFICACION_INGRESADA"] = "Replanificaci\u00F3n Ingresada";
    EstadoPlanificacionConSolicitud["REPLANIFICADA"] = "Replanificada";
    EstadoPlanificacionConSolicitud["EN_EJECUCION"] = "En ejecuci\u00F3n";
    // REPLANIFICADA = "Planificada no ejecutada-Reprogramada"
})(EstadoPlanificacionConSolicitud = exports.EstadoPlanificacionConSolicitud || (exports.EstadoPlanificacionConSolicitud = {}));
var TabSolicitudActiva;
(function (TabSolicitudActiva) {
    TabSolicitudActiva[TabSolicitudActiva["VACACIONES_PLANIFICADAS"] = 1] = "VACACIONES_PLANIFICADAS";
    TabSolicitudActiva[TabSolicitudActiva["PERMISOS_IMPUTABLES"] = 2] = "PERMISOS_IMPUTABLES";
    TabSolicitudActiva[TabSolicitudActiva["REINTEGRO"] = 3] = "REINTEGRO";
    TabSolicitudActiva[TabSolicitudActiva["REPROGRAMACION"] = 4] = "REPROGRAMACION";
    TabSolicitudActiva[TabSolicitudActiva["PERMISOS_HORAS"] = 5] = "PERMISOS_HORAS";
    TabSolicitudActiva[TabSolicitudActiva["PERMISOS_IMPUTABLES_DIAS"] = 6] = "PERMISOS_IMPUTABLES_DIAS";
    TabSolicitudActiva[TabSolicitudActiva["PERMISOS_IMPUTABLES_HORAS"] = 7] = "PERMISOS_IMPUTABLES_HORAS";
})(TabSolicitudActiva = exports.TabSolicitudActiva || (exports.TabSolicitudActiva = {}));
//# sourceMappingURL=TypesSolicitudVacaciones.js.map